module.exports = __webpack_public_path__ + "static/media/PatoFooter.56b87cc4.svg";